import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@progress/kendo-react-tooltip';
import React, { useEffect } from 'react';
import { useForceRefresh } from '../../common/useForceRefresh';
import { STooltipWarning } from './TooltipWarning.styled';

interface IProps {
  message: string;
  absolutePos?: boolean;
}

const TooltipWarning: React.FC<IProps> = ({ message, absolutePos = true }) => {
  const { refresh, isVisible } = useForceRefresh();

  useEffect(() => {
    refresh();
  }, [message]);

  return (
    <div style={{ position: 'relative' }}>
      {isVisible && (
        <STooltipWarning absolutePos={absolutePos}>
          <Tooltip anchorElement="target" position="top" openDelay={0} style={{ maxWidth: '300px' }}>
            <FontAwesomeIcon title={message} icon={faExclamationTriangle} size="sm" />
          </Tooltip>
        </STooltipWarning>
      )}
    </div>
  );
};

export default TooltipWarning;
